<template>
  <div class="l-footer-bar _page">
    <div class="_container container">
      <div class="about" :span="4">
        <h4 class="info-title">关于我们</h4>
        <span
          class="info"
          v-for="(item, index) of aboutUs"
          :key="index"
          :class="{_route:item.url}"
          @click="onRtoueClick(item)"
        >{{ item.label }}</span>
      </div>

      <div class="attention" :span="4">
        <h4 class="info-title">关注我们</h4>

        <div class="qr-code">
          <l-img :src="qrCode"></l-img>
        </div>
        <span class="tip">微信公众号</span>
      </div>

      <div class="contact">
        <h4 class="info-title">联系我们</h4>
        <p class="info" v-for="item of address" :key="item">{{ item }}</p>
      </div>
    </div>
    <div
      class="copy-right _container"
      @click="onCopyRightClk"
    >Copyright © 2019 中科德诺（深圳）科技有限公司 版权所有 粤ICP备19044990号</div>
  </div>
</template>
<script>
import qrCode from "@/assets/img/微信公众号@2x.png";

export default {
  name: "l-footer-bar",
  data() {
    return {
      qrCode,
      aboutUs: [
        {
          label: "公司简介",
          url: "/about-us",
        },
        {
          label: "荣誉证书",
          url: "/about-us",
        },
      ],

      address: [
        "电话：0769-22223632",
        "邮箱：zkdn@zkdntech.com",
        "地址：东莞市南城街道保利都汇大厦1栋715",
      ],
    };
  },
  methods: {
    onRtoueClick({ url }) {
      window.scroll(0, 0);
      this.$router.push(url);
    },
    onCopyRightClk() {
      window.location.href = "http://beian.miit.gov.cn";
    },
  },
};
</script>
<style lang="scss" scoped>
.l-footer-bar {
  box-sizing: border-box;
  padding-top: 40px;
  height: 290px;
  background: $color_footer_bg;

  $about_width: 420px;
  $attention_width: 84px;

  .about {
    float: left;
    width: 420px;
  }
  .attention {
    float: right;
    width: $attention_width;
    text-align: center;
    .qr-code {
      margin: auto;
      width: $attention_width;
      height: $attention_width;
    }
    .tip {
      @include font_content;
      display: inline-block;
      margin-top: 10px;
    }
  }

  .contact {
    margin: 0 $attention_width 0 $about_width;
  }

  .info-title {
    margin-bottom: 20px;
    font-size: $font_size_info_title;
    color: $font_color_light;
  }

  .info {
    @include font_content;
    display: block;
    position: relative;
    // padding-left: 10px;
    margin-bottom: 20px;
    &._route {
      cursor: pointer;
      transition: all 0.3s;
      &:hover {
        color: $color_6;
      }
    }

    // &::before{
    //     $size: 4px;
    //     content: '';
    //     display: block;
    //     position: absolute;
    //     top: 0;
    //     bottom: 0;
    //     left: 0;
    //     margin: auto;
    //     width: $size;
    //     height: $size;
    //     background: $font_color_content;
    //     border-radius: 100%;
    // }
  }

  .copy-right {
    $h: 72px;
    margin-top: 20px;
    height: $h;
    line-height: $h;
    border-top: 1px solid #2f313d;
    text-align: center;
    color: $font_color_content;
    cursor: pointer;
    transition: 0.35s;
    &:hover {
      color: $color_6;
    }
  }
}
</style>
